class Registration {
    constructor() {
        const categories = document.querySelectorAll('.js-registrations-category');
        categories.forEach((item) => {
            this.bindCategory(item);
        });

        this.initContent();
        const menuRegistrations = document.querySelectorAll('.js-menu-registrations');
        menuRegistrations.forEach((menu) => {
            menu.addEventListener('click', (e) => {
                this.bindMenuItem(menu);
                e.preventDefault();
            });
        });

        document.querySelectorAll('.js-more-details').forEach((item) => {
            item.addEventListener('click', () => {
                item.closest('.feature-title').querySelector('.subtitle').classList.toggle('hidden');
            });
        });
    }

    initContent() {
        const firstMenuItem = document.querySelector('.js-menu-item');
        const firstMenuCategory = document.querySelector('.js-menu-registrations');
        if (firstMenuItem) {
            firstMenuItem.classList.remove('hidden');
        }
        if (firstMenuCategory) {
            firstMenuCategory.classList.add('active');
        }
    }

    bindCategory(item) {
        const featuresCategories = item.querySelectorAll('.js-registration-line');
        const categories = item.querySelectorAll('.js-registration-title');

        featuresCategories.forEach((category) => {
            this.bindFeaturesCategory(category, categories);
        });
    }

    bindFeaturesCategory(category, categories) {
        const features = category.querySelectorAll('.js-registration-cell');
        features.forEach((feature, index) => {
            feature.addEventListener('mouseover', () => {
                categories[index].classList.add('active');
            });
            feature.addEventListener('mouseout', () => {
                categories.forEach((category) => {
                    category.classList.remove('active');
                });
            });
        });
    }

    bindMenuItem(menu) {
        document.querySelectorAll('.js-menu-item').forEach((menuItem) => {
            menuItem.classList.add('hidden');
        });
        document.querySelectorAll('.js-menu-registrations').forEach((menuItem) => {
            menuItem.classList.remove('active');
        });
        const menuContent = document.querySelector(`#category-${menu.dataset.categoryId}`);
        menuContent.classList.remove('hidden');
        menu.classList.add('active');
    }
}

export default Registration;
